import { lazy } from "react";

const routes = [
  {
    path: "/product_variant",
    element: lazy(() => import("../pages/ProductVariant/viewall")),
  },
  {
    path: "/product_variant/:productId",
    element: lazy(() => import("../pages/ProductVariant")),
  },
  {
    path: "/product_variant/add/:productId",
    element: lazy(() => import("../pages/ProductVariant/create")),
  },
  {
    path: "/product_variant/edit/:id",
    element: lazy(() => import("../pages/ProductVariant/edit")),
  },
  {
    path: "/product_activation",
    element: lazy(() => import("../pages/ProductVariant/Product Activation")),
  },
];

export default routes;
